export default function ArrowDropdown({
  color = "#f03737",
  translate = "0 13.274",
  rotate = "-90",
  width = "30",
  height = "30",
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 30 30"
    >
      <g
        id="Group_836"
        data-name="Group 836"
        transform="translate(-6557 15193)"
      >
        <circle
          id="Ellipse_2605"
          data-name="Ellipse 2605"
          cx="15"
          cy="15"
          r="15"
          transform="translate(6557 -15193)"
          fill={color}
        />
        <g id="Layer_1" transform="translate(6563.932 -15187.24)">
          <path
            id="Path_4149"
            data-name="Path 4149"
            d="M23.079,19.019l-1.372-1.224V13.057a5.878,5.878,0,0,0-4.787-5.99V6.422A1.514,1.514,0,0,0,15.325,5a1.514,1.514,0,0,0-1.594,1.422v.646a5.867,5.867,0,0,0-4.787,5.99v4.738L7.572,19.019a.938.938,0,0,0,.744,1.619H22.324A.939.939,0,0,0,23.079,19.019Zm-3.5-.275H11.071V13.057a4.083,4.083,0,0,1,4.254-4.265,4.083,4.083,0,0,1,4.254,4.265Zm-4.254,4.738a2.027,2.027,0,0,0,2.127-1.894H13.2A2.018,2.018,0,0,0,15.325,23.481Z"
            transform="translate(-7.256 -5)"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
}
